
import React from 'react';
import { Button } from '../ui/button';

const ResumeButton: React.FC = () => {
  return (
    <Button asChild size="sm" className="hover-ripple">
      <a
        href="https://drive.google.com/file/d/1Jn88Lw-iZnhX-qiaAqKx-14F_M1uYHWI/view?usp=drive_link"
        target="_blank"
        rel="noopener noreferrer"
        className="font-medium"
      >
        Resume
      </a>
    </Button>
  );
};

export default ResumeButton;
